<router-outlet></router-outlet>
<ngx-spinner type = "ball-scale-ripple-multiple"></ngx-spinner>
